import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {IonicModule} from '@ionic/angular';

import {TranslateModule} from '@ngx-translate/core';
import {EffectsModule} from '@ngrx/effects';
import {SopiScrollModule} from '../../../sopi/components/sopi-scroll/sopi-scroll.module';
import {MeineAufgabenPage} from './meine-aufgaben.page';
import {FormsModule} from '@angular/forms';
import {MeineAufgabenPageUiEffects} from './meine-aufgaben.effects.ui';
import {
    IncidentsIncidentAbgebenEffects,
    IncidentsIncidentAbschliessenEffects,
    IncidentsIncidentAktualisierenEffects,
    IncidentsIncidentBildEntfernenEffects,
    IncidentsIncidentBildHinzufuegenEffects,
    IncidentsIncidentDetailEffects,
    IncidentsIncidentMeldungAktualisierenEffects,
    IncidentsIncidentMeldungErfassenEffects,
    IncidentsIncidentNichtOkErfassenEffects,
    IncidentsIncidentOkErfassenEffects,
    IncidentsIncidentUebernehmenEffects, IncidentsMeineIncidents2Effects
} from '../../../client-ngrx/incidents';
import {StoreModule} from '@ngrx/store';
import {reducers} from './meine-aufgaben.reducer';
import {SopiComponentsModule} from '../../shared/sopi-components/sopi-components.module';
import {MeineAufgabenPageWsEffects} from './meine-aufgaben.effects.ws';
import {MeineAufgabenPageRoutingModule} from './meine-aufgaben-routing.module';
import {PipesSharedModule} from '../../shared/pipes/pipes-shared.module';


@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        TranslateModule,
        MeineAufgabenPageRoutingModule,
        StoreModule.forFeature('MeineAufgabenPage', reducers),
        EffectsModule.forFeature([
            MeineAufgabenPageUiEffects,
            MeineAufgabenPageWsEffects,

            IncidentsMeineIncidents2Effects,
            IncidentsIncidentDetailEffects,
            IncidentsIncidentAbschliessenEffects,
            IncidentsIncidentUebernehmenEffects,
            IncidentsIncidentAbgebenEffects,
            IncidentsIncidentOkErfassenEffects,
            IncidentsIncidentNichtOkErfassenEffects,
            IncidentsIncidentAktualisierenEffects,
            IncidentsIncidentMeldungErfassenEffects,
            IncidentsIncidentMeldungAktualisierenEffects,
            IncidentsIncidentBildHinzufuegenEffects,
            IncidentsIncidentBildEntfernenEffects
        ]),
        SopiScrollModule,
        FormsModule,
        SopiComponentsModule,
        PipesSharedModule,
    ],
    declarations: [MeineAufgabenPage],
    entryComponents: [MeineAufgabenPage],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class MeineAufgabenPageModule {
}
